import axios from 'axios';
import { saveAs } from 'file-saver';
import { ENDPOINTS } from '../constants';
import { IWithdrawRequest } from '../types/IWithdrawRequest';
import { EWithdrawStatus } from '../types/EWithdrawStatus';
import { TVoidAxios } from '../types/TVoidAxios';

export interface IWithdrawRequestsParams {
    pageNumber: number;
    pageSize: number;
    searchQuery?: string;
    userId?: string;
    statuses?: string | undefined;
    isVerified?: boolean | undefined;
    createdFrom?: string;
    createdTo?: string;
}

interface IWithdrawRequestsResponse {
    total: number;
    entities: IWithdrawRequest[];
}

export const getWithdrawRequests = async (params: IWithdrawRequestsParams): Promise<IWithdrawRequestsResponse> => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.withdrawRequests}`, { params });
    return res.data;
};

export interface IWithdrawRequestParams {
    id: string;
}

export const getWithdrawRequest = async (params: IWithdrawRequestParams): Promise<IWithdrawRequest> => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.withdrawRequest}/${params.id}`);
    return res.data;
};

export interface ISetPaymentAccountVerified {
    userId: string;
    iban: string;
    isVerified: boolean;
}

export const setPaymentAccountVerified = async (params: ISetPaymentAccountVerified): Promise<TVoidAxios> => {
    const res = await axios.put<Promise<TVoidAxios>>(
        `${axios.defaults.baseURL}${ENDPOINTS.withdrawSetPaymentAccountVerified}`,
        {},
        { params }
    );
    return res.data;
};

export interface ISetPaymentRequestStatus {
    requestId: string;
    status: EWithdrawStatus;
}

export const setPaymentRequestStatus = async (params: ISetPaymentRequestStatus): Promise<TVoidAxios> => {
    const res = await axios.put<Promise<TVoidAxios>>(
        `${axios.defaults.baseURL}${ENDPOINTS.setPaymentRequestStatus}`,
        {},
        { params }
    );
    return res.data;
};

export interface IExportToExcel {
    userId?: string;
    searchQuery?: string;
    pageNumber: number;
    pageSize: number;
    isVerified?: boolean;
    createdFrom?: string;
    createdTo?: string;
    statuses?: string;
}

export const exportToExcel = async (params: IExportToExcel): Promise<TVoidAxios> => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.exportToExcel}`, {
        params,
        responseType: 'arraybuffer',
        headers: {
            Accept: 'application/xlsx',
        },
    });

    const blob = new Blob([res.data], {
        type: 'application/xlsx',
    });

    const fileName = res.headers['content-disposition'].match(/filename="([^"]+)"/)[1];

    saveAs(blob, fileName);

    return res.data;
};
